import { render, staticRenderFns } from "./ModalAddService.vue?vue&type=template&id=2423aa29&"
import script from "./ModalAddService.vue?vue&type=script&lang=js&"
export * from "./ModalAddService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports